import ToggleInput from "../components/inputs/ToggleInput";
import {db} from "../db";
import {useEffect, useState} from "react";
import {usePromptusAPIDispatch, usePromptusAPIState} from "../context/PromptusAPIContext";
import Swal from "sweetalert2";
import { useAccountContext } from "../context/AccountContext";
import download from "downloadjs";
import Dexie from "dexie";
import OpenFolder from "../images/icons/folder-open.svg";
import { exportDB } from "dexie-export-import";
import { Modal } from 'react-responsive-modal';
import { nodeTestAdd, nodeTestGet, nodeTestDelete, clearApiPreferenceCache, getApiBaseUrl } from "../api-helper";
import { useNavigate } from "react-router-dom";
import { useMenuState, useMenuDispatch } from "../context/MenuContext";
import StartIcon from "../images/icons/image-card-icons/card-icon-start.svg"
import StopIcon from "../images/icons/image-card-icons/card-icon-stop.svg"
import SquareStopIcon from "../images/icons/image-card-icons/card-icon-stop-svg_square.svg"
import axios from "axios";
import { useElectronEnvironment } from '../hooks/useElectronEnvironment';
import { FeatureTooltip } from '../components/FeatureGate';
import electronBridge from '../utils/electronBridge';

export default function Settings() {
    const apiStateDispatch = usePromptusAPIDispatch();
    const apiContext = usePromptusAPIState();
    const accountContext = useAccountContext();
    const { canUseFeature } = useElectronEnvironment();
    const canSelectDirectory = canUseFeature('directorySelection');
    const [loading, setLoading] = useState(false);
    const [importLoading, setImportLoading] = useState(false);
    const [lowMemory, setLowMemory] = useState(true);
    const [safeMode, setSafeMode] = useState(true);
    const [testMode, setTestMode] = useState(false);
    const [playSounds, setPlaySounds] = useState(true);
    const [fullPrecision, setFullPrecision] = useState(false);
    const [halfModel, setHalfModel] = useState(false);
    const [cpuGeneration, setCpuGeneration] = useState(false);
    const [cpuOffloading, setCpuOffloading] = useState(false);
    const [enableGPU, setEnableGPU] = useState(false);
    const [enableCPU, setEnableCPU] = useState(false);
    const [enableCosy, setEnableCosy] = useState(false);
    const [categoryPopup, setCategoryPopup] = useState(true);
    const [enableAnimations, setEnableAnimations] = useState(false);
    const [useDevApi, setUseDevApi] = useState(false)
    const navigate = useNavigate();
    const [accountNo, setAccountNo] = useState("");
    const [apiHost, setApiHost] = useState(`http://${process.env.REACT_APP_PROMPTUS_LOCALHOST || 'localhost'}`);
    const [apiLocalGPU, setApiLocalGPU] = useState("http://localhost:7111/");
    const [apiLocalCPU, setApiLocalCPU] = useState("http://localhost:7112/");
    const [apiLocalCosy, setApiLocalCosy] = useState("http://localhost:8190/");
    const [batchNumber, setBatchNumber] = useState(1);
    const [message, setMessage] = useState({type: "", message: ""});
    const [serverinfo, setServerInfo] = useState({});
    const [directory, setDirectory] = useState("");
    const [openNodeTest, setOpenNodeTest] = useState(false);
    const [nodeAccountNo, setNodeAccountNo] = useState("");
    const [nodeloading, setNodeLoading] = useState(false);
    const [preferOpenAIModel, setPreferOpenAIModel] = useState(false);
    const [useAIHordeModels, setUseAIHordeModels] = useState(false);
    const menuState = useMenuState();
    const menuDispatch = useMenuDispatch();
    const [statusError, setStatusError] = useState(false);
    const [statusErrorMessage, setStatusErrorMessage] = useState("");

    const ipcRenderer = electronBridge.ipcRenderer

    // Utility function to try custom protocol with fallback
    const tryProtocolWithFallback = (protocolUrl, fallbackUrl) => {
        let hasBlurred = false;
        let timeoutId;

        const cleanup = () => {
            window.removeEventListener('blur', handleBlur);
            if (timeoutId) clearTimeout(timeoutId);
        };

        const handleBlur = () => {
            hasBlurred = true;
            cleanup();
        };

        // Add blur listener to detect if protocol launched successfully
        window.addEventListener('blur', handleBlur);

        // Set timeout for fallback
        timeoutId = setTimeout(() => {
            if (!hasBlurred) {
                cleanup();
                // Protocol likely failed, redirect to fallback
                window.open(fallbackUrl, '_blank');
            }
        }, 1500);

        // Try the protocol
        try {
            window.location.assign(protocolUrl);
        } catch (error) {
            // If immediate error, cleanup and go to fallback
            cleanup();
            window.open(fallbackUrl, '_blank');
        }
    };

    const getSettings = async () => {
        setLoading(true);
        await db.settings.toArray(settings => {
            settings.forEach(setting => {
                switch(setting.key) {
                    case "low_memory":
                        setLowMemory(setting.value);
                        break;
                    case "safe_mode":
                        setSafeMode(setting.value);
                        break;
                    case "test_mode":
                        setTestMode(setting.value);
                        break;
                    case "play_sounds":
                        setPlaySounds(setting.value);
                        break;
                    case "full_precision":
                        setFullPrecision(setting.value);
                        break;
                    case "half_model":
                        setHalfModel(setting.value);
                        break;
                    case "cpu_generation":
                        setCpuGeneration(setting.value);
                        break;
                    case "cpu_offloading":
                        setCpuOffloading(setting.value);
                        break;
                    case "UUID":
                        setAccountNo(setting.value);
                        break;
                    case "api_host":
                        setApiHost(setting.value);
                        break;    
                    case "image_batch_size":
                        setBatchNumber(Number(setting.value));
                        break;
                    case "category_popup":
                        setCategoryPopup(setting.value);
                        break;
                    case "local_gpu":
                        setApiLocalGPU(setting.value);
                        break;
                    case "local_cpu":
                        setApiLocalCPU(setting.value);
                        break;
                    case "local_cosy":
                        setApiLocalCosy(setting.value);
                        break;     
                    case "enable_animations":
                        setEnableAnimations(setting.value);
                        break;
                    case "prefer_openai_model":
                        setPreferOpenAIModel(setting.value);
                        break;
                    case "use_aihorde_models":
                        setUseAIHordeModels(setting.value);
                        break;
                    case "use_dev_api":
                        setUseDevApi(setting.value);
                        break;     
                    case "local_directory":
                        setDirectory(setting.value);
                        break;
                    default:
                        // do nothing.
                        return;
                }
            });
        });
    }

    useEffect(() => {
        getSettings().then(() => setLoading(false));
    }, []);

    useEffect(() => {
        db.settings.put({key: 'image_batch_size', value: Number(batchNumber)});
        setBatchNumber(batchNumber);
    }, [batchNumber])

    const handleLowMemoryMode = (checked) => {
        db.settings.put({key: 'low_memory', value: checked});
        setLowMemory(checked);
    }

    const handleSafeMode = (checked) => {
        db.settings.put({key: 'safe_mode', value: checked});
        setSafeMode(checked);
    }

    const handleTestMode = (checked) => {
        db.settings.put({key: 'test_mode', value: checked});
        setTestMode(checked);
    }

    const handlePlaySounds = (checked) => {
        db.settings.put({key: 'play_sounds', value: checked});
        setPlaySounds(checked);
    }

    const handleFullPrecision = (checked) => {
        db.settings.put({key: 'full_precision', value: checked});
        setFullPrecision(checked);
    }

    const handleHalfModel = (checked) => {
        db.settings.put({key: 'half_model', value: checked});
        setHalfModel(checked);
    }

    const handleCpuGeneration = (checked) => {
        db.settings.put({key: 'cpu_generation', value: checked});
        setCpuGeneration(checked);
    }

    const handleCpuOffloading = (checked) => {
        db.settings.put({key: 'cpu_offloading', value: checked});
        setCpuOffloading(checked);
    }
    
    const handleCategoryPopup = (checked) => {
        db.settings.put({key: 'category_popup', value: checked});
        setCategoryPopup(checked);
    }

    const handleEnableAnimations = (checked) => {
        db.settings.put({key: 'enable_animations', value: checked});
        setEnableAnimations(checked);
    }

    const handleUseDevApi = async (checked) => {
        try {
            // Update the setting
            await db.settings.put({key: 'use_dev_api', value: checked});
            setUseDevApi(checked);
            clearApiPreferenceCache(); // Clear the cached API preference
            
            // Clear cosyflows table and sync status
            console.log("[Settings] Clearing cosyflows for API switch...");
            await db.cosyflows.clear();
            await db.settings.delete('cosyflowsSyncStatus');
            
            // Get the new API base URL (will use the updated setting)
            const apiBase = checked ? 'https://api.dev.promptus.ai' : 'https://api.promptus.ai';
            console.log(`[Settings] Fetching cosyflows from ${apiBase}...`);
            
            try {
                // Fetch fresh cosyflows from the new API
                const response = await axios.get(`${apiBase}/api/cosyflows/query`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
                    }
                });
                
                if (response.data && response.data.cosyflows) {
                    console.log(`[Settings] Received ${response.data.cosyflows.length} cosyflows`);
                    
                    // Store each cosyflow in IndexedDB
                    let successCount = 0;
                    for (const item of response.data.cosyflows) {
                        try {
                            // Parse the cosyflow JSON string
                            const cosyflowData = JSON.parse(item.cosyflow);
                            
                            // Store in IndexedDB
                            await db.cosyflows.add({
                                data: cosyflowData,
                                timestamp: Date.now()
                            });
                            successCount++;
                        } catch (error) {
                            console.error(`[Settings] Error parsing/storing cosyflow:`, error);
                        }
                    }
                    
                    console.log(`[Settings] Successfully stored ${successCount} cosyflows`);
                    
                    // Update sync status
                    await db.settings.put({
                        key: 'cosyflowsSyncStatus',
                        value: {
                            lastSync: Date.now(),
                            syncedCount: successCount
                        }
                    });
                }
            } catch (fetchError) {
                console.error("[Settings] Error fetching cosyflows:", fetchError);
                // Continue with the reload even if fetch fails
            }
            
            // Reload the page
            setTimeout(() => {
                navigate('/')
                document.location.reload();
            }, 1000);
            
        } catch (error) {
            console.error("[Settings] Error in handleUseDevApi:", error);
            // Still try to reload even if there's an error
            setTimeout(() => {
                navigate('/')
                document.location.reload();
            }, 1000);
        }
    }

    const handleEnableGPU = async(checked) => {
        if (apiLocalGPU !== "") {
            fetch(apiLocalGPU, {mode: "no-cors"})
            .then(res => {
                if (checked) {
                    db.settings.put({key: 'api_host', value: apiLocalGPU})
                    .then(() => {
                        apiStateDispatch({type: 'offline'});
                        apiStateDispatch({type: 'setHost', host: apiLocalGPU});
                        apiStateDispatch({type: 'setActiveGPU', server: checked})
                    })
                }
                setEnableGPU(checked);
                setEnableCPU(false);
            })
            .catch(err => {
                Swal.fire({
                    title: "Check local server",
                    text: "The local server was not found. Please open promptus manager to start the server.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                    showDenyButton: true,
                    denyButtonText: "Open Manager",
                    denyButtonColor: "#190A4E"
                }).then((result) => {
                    if (result.isDenied) {
                        if (electronBridge.isElectron) {
                            ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('apiKey'))
                        } else {
                            const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('apiKey')}`;
                            const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
                            tryProtocolWithFallback(protocolUrl, fallbackUrl);
                        }
                    }
                })
            })
    
            if (!enableCPU && !checked) {
                apiStateDispatch({type: 'online'})
            }
        } else {
            Swal.fire({
                title: "Local Server not saved",
                text: "Your local server is not saved. Please save your local server settings before using it.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            })
        }
    }

    const handleEnableCPU = async(checked) => {
        if (apiLocalCPU !== "") {
            fetch(apiLocalCPU, {mode: "no-cors"})
            .then(res => {
                if (checked) {
                    db.settings.put({key: 'api_host', value: apiLocalCPU})
                    .then(() => {
                        apiStateDispatch({type: 'offline'});
                        apiStateDispatch({type: 'setHost', host: apiLocalCPU});
                        apiStateDispatch({type: 'setActiveCPU', server: checked})
                    })
                }
                setEnableCPU(checked);
                setEnableGPU(false);
            })
            .catch(err => {
                Swal.fire({
                    title: "Check local server",
                    text: "The local server was not found. Please open promptus manager to start the server.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                    showDenyButton: true,
                    denyButtonText: "Open Manager",
                    denyButtonColor: "#190A4E"
                }).then((result) => {
                    if (electronBridge.isElectron) {
                        ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('apiKey'))
                    } else {
                        const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('apiKey')}`;
                        const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
                        tryProtocolWithFallback(protocolUrl, fallbackUrl);
                    }
                })
            })
            
            if (!checked && !enableGPU) {
                apiStateDispatch({type: 'online'})
            }
        } else {
            Swal.fire({
                title: "Local Server not saved",
                text: "Your local server is not saved. Please save your local server settings before using it.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            })
        }
    }

    const handleEnableCosy = async(checked) => {
        if (apiLocalCosy !== "") {
            fetch(apiLocalCosy, {mode: "no-cors"})
            .then(res => {
                if (checked) {
                    db.settings.put({key: 'api_host', value: apiLocalCosy})
                    .then(() => {
                        apiStateDispatch({type: 'offline'});
                        apiStateDispatch({type: 'setHost', host: apiLocalCosy});
                        apiStateDispatch({type: 'setActiveCosy', server: checked})
                    })
                }
                setEnableCosy(checked)
                setEnableCPU(false);
                setEnableGPU(false);
            })
            .catch(err => {
                Swal.fire({
                    title: "Check local server",
                    text: "The local server was not found. Please open promptus manager to start the server.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                    showDenyButton: true,
                    denyButtonText: "Open Manager",
                    denyButtonColor: "#190A4E"
                }).then((result) => {
                    if (electronBridge.isElectron) {
                        ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('apiKey'))
                    } else {
                        const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('apiKey')}`;
                        const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
                        tryProtocolWithFallback(protocolUrl, fallbackUrl);
                    }
                })
            })
            
            if (!checked && !enableGPU && !enableCosy) {
                apiStateDispatch({type: 'online'})
            }
        } else {
            Swal.fire({
                title: "Local Server not saved",
                text: "Your local server is not saved. Please save your local server settings before using it.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            })
        }
    }

    const handlePreferOpenAIModel = (checked) => {
        db.settings.put({key: 'prefer_openai_model', value: checked});
        setPreferOpenAIModel(checked);
        alert("Functionality to be defined")
    }

    const handleUseAIHordeModels = (checked) => {
        db.settings.put({key: 'use_aihorde_models', value: checked});
        setUseAIHordeModels(checked);
        alert("Functionality to be defined")
    }

    useEffect(() => {
        if (apiContext.activeGPU) {
            setEnableGPU(true)
            setEnableCPU(false)
        }

        if (apiContext.activeCPU) {
            setEnableCPU(true)
            setEnableGPU(false)
        }

    },[])

    // Add event listener for selected directory
    useEffect(() => {
        // Only set up IPC listeners if in Electron environment
        if (!canSelectDirectory) {
            return;
        }
        
        const handleSelectedDirectory = (event, path) => {
            setDirectory(path);
        };
        
        ipcRenderer.on('selectedDirectory', handleSelectedDirectory);
        
        // Cleanup listener on unmount
        return () => {
            ipcRenderer.removeListener('selectedDirectory', handleSelectedDirectory);
        };
    }, [canSelectDirectory]);

    const getBenchmark = async (host) => {
        return await fetch(`${host}/api/generate/get-info`)
            .then(response => response.json());
    }

    const saveApiSettings = async (localhost, serverType) => {
        if (localhost !== "") {
            setLoading(true);
            setMessage({type: "", message: ""});
            if (serverType === "Cosy") {
                await db.settings.put({key: 'api_host', value: localhost});
                apiStateDispatch({type: 'offline'});
                apiStateDispatch({type: 'setHost', host: localhost});
                await db.settings.put({key: 'local_cosy', value: localhost});
                setEnableCosy(true);
                setEnableGPU(false);
                setEnableCPU(false);
            } else {
                await getBenchmark(localhost).then(async (data) => {
                    setMessage({type: "info", message: `Server settings saved. Version: ${data.version}, GPU: ${data.gpu}, Benchmark Score: ${data.benchmark}`});
                    if (data.benchmark) {
                        await db.settings.put({key: 'api_host', value: localhost});
                        apiStateDispatch({type: 'offline'});
                        apiStateDispatch({type: 'setHost', host: localhost});
                        if (serverType === "GPU") {
                            db.settings.put({key: 'local_gpu', value: localhost});
                            setEnableGPU(true); 
                            setEnableCPU(false);
                            setEnableCosy(false);
                            apiStateDispatch({type: 'setActiveGPU', server: true})
                        } else {
                            db.settings.put({key: 'local_cpu', value: localhost});
                            setEnableGPU(false);
                            setEnableCPU(true);
                            setEnableCosy(false);
                            apiStateDispatch({type: 'setActiveCPU', server: true})
                        }
                    }
                    setServerInfo(data);
                }).catch(e => {
                    console.error(e);
                    setMessage({type: "error", message: "Could not get server info, check if local server is running."});
                }).finally(() => {
                    setLoading(false);
                });

            }
        } else {
            Swal.fire({
                title: "No input",
                text: "Please type in your localhost url with your port to save. The localhost url begins with http://localhost:[PORT]/",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            })
        }
    }


    const clearApiSettings = async () => {
        // setLoading(true);
        setMessage({type: "", message: ""});
        await db.settings.put({key: 'api_host', value: `http://${process.env.REACT_APP_PROMPTUS_LOCALHOST}`});
        apiStateDispatch({type: 'offline'});
        apiStateDispatch({type: 'setHost', host: `http://${process.env.REACT_APP_PROMPTUS_LOCALHOST}`});
        setMessage({type: "info", message: "Server settings reset."});
    }

    const exportBackup = async () => {
        const blob = await exportDB(db,{prettyJson: true});
        console.log(blob);
        // download(blob, "promptusai_backup.json", "application/json");
    }  

    const importBackup = async (e) => {
        console.log("Importing");
        setImportLoading(true)
        // Create a new Dexie instance
        const newDB = new Dexie('promptus-pwa-db');
        newDB.version(10).stores({
            collection: '++id, &uid, prompt, queue, timestamp',
            images: '++id, uid, image, seed, inCollection, model, &hash, online, tag',
            collectedImages: '++id, uid, image, seed, model, &hash, online, tag, prompt, public',
            settings: '&key, value',
            account: '&key, value'
        })
    
        try {
            // Import the data from the file into the new database
            await newDB.collection.clear()
            await newDB.images.clear()
            await newDB.collectedImages.clear()
            await newDB.settings.clear()
            await newDB.account.clear()

            await newDB.import(e.target.files[0]);
            
            setImportLoading(false)        
            console.log('Import successful!');
        } catch (error) {
            setImportLoading(false)        
            console.error('Error importing database:', error);
        }
    };

    const loadNodeTest = () => {
        console.log("Load node testing");
        console.log("Account Number: ", accountContext.accountDetails.accountNo);
                nodeTestGet(accountContext.accountDetails.accountNo)
                .then(data => {
			setNodeAccountNo(data.fulfillAccountNo || '');
			console.log("Set Fulfill Account Number: ", nodeAccountNo);
                });
	setOpenNodeTest(true);
    }

    const saveNodeTest = () => {
        setNodeLoading(true);
        console.log("Save node testing");
        console.log("Node Account Number: ", nodeAccountNo);
        console.log("Account Number: ", accountContext.accountDetails.accountNo);
	if(nodeAccountNo === '') {
		nodeTestDelete(accountContext.accountDetails.accountNo).then(() => {
            setNodeLoading(false);
            Swal.fire({
                title: "Node Testing",
                text: "Account Number Deleted Successfully",
                icon: "success",
                showConfirmButton: false,
                timer: 1000,
            }).then(() => {
                setOpenNodeTest(false);
            });
        })
	} else {
		nodeTestAdd(accountContext.accountDetails.accountNo, nodeAccountNo).then(() => {
            setNodeLoading(false);
            Swal.fire({
                title: "Node Testing",
                text: "Account Number Added Successfully",
                icon: "success",
                showConfirmButton: false,
                timer: 1000,
            }).then(() => {
                setOpenNodeTest(false);
            });
        })
	}
        setNodeLoading(false);
    }

    const saveDirectory = () => {
        if (directory.indexOf("\\") !== -1) {
            setDirectory(directory.replace(/\\/g, '/'));
        }
        setTimeout(() => {
            db.settings.put({key: 'local_directory', value: directory});
            console.log("Directory Saved into: ", directory); 
        },1000)
    }

    const resetMenuOrder = () => {
        menuDispatch({ type: 'RESET_ORDER' });
    };

    const startPManagerServer = async (process) => {
        setStatusError(false);
        setStatusErrorMessage("");
        const response = await axios.get(`http://localhost:7412/run-pmanager-${process}-server`);
        if (response.data.status && response.data.status === "error"){
            setStatusError(true);
            setStatusErrorMessage(response.data.message);
        }    
        console.log(response);
               
    }

    const stopPManagerServer = async (process) => {
        setStatusError(false);
        setStatusErrorMessage("");
        const response = await axios.get(`http://localhost:7412/stop-pmanager-${process}-server`);       
        console.log(response);
        if (response.data.status && response.data.status === "error"){
            setStatusError(true);
            setStatusErrorMessage(response.data.message);
        }  
    }

    return (
        <div className={"px-4 relative mx-auto"}>
            <h1 className={"text-2xl py-2 font-bold flex flex-row items-center"}>
                <span>Settings</span>
                <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"}/>
                <button className="w-5 opacity-0" onClick={() => loadNodeTest()}>I</button>
            </h1>
            <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full md:max-w-screen-md mx-auto"}>
                {loading ? <div className={"font-bold"}>Loading stored settings.</div> : null}
                <h2 className={"text-xl font-bold mb-10"}>Generator Settings</h2>
                <h3 className={"text-lg font-bold mb-5"}>Menu Customization</h3>
                <div className="flex flex-row justify-center space-x-4 mb-5">
                    <button 
                        onClick={resetMenuOrder}
                        className={"rounded-lg p-2 bg-red-800/50 hover:bg-red-800/70 text-white font-semibold shadow"}
                    >
                        Reset Menu Order
                    </button>
                </div>
                <div className="text-sm text-center text-white/70 mb-10">
                    You can drag and drop items in the navigation menu on the left side to rearrange them.
                </div>
                <hr/>
                <div className="mb-10 grid grid-cols-2">
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"playSounds"} onChange={(e) => handlePlaySounds(e.target.checked)}
                                     checked={playSounds}/>
                        <label htmlFor={"playSounds"} className="inline-block ml-2 text-sm font-medium">Play
                            Sounds</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"enableAnimations"} onChange={(e) => handleEnableAnimations(e.target.checked)}
                                     checked={enableAnimations}/>
                        <label htmlFor={"enableAnimations"} className="inline-block ml-2 text-sm font-medium">Enable
                            Animations</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"safeMode"} onChange={(e) => handleSafeMode(e.target.checked)}
                                     checked={safeMode}/>
                        <label htmlFor={"safeMode"} className="inline-block ml-2 text-sm font-medium">Safe Mode</label>
                    </div>
                    {/* <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"lowMemory"} onChange={(e) => handleLowMemoryMode(e.target.checked)}
                                     checked={lowMemory}/>
                        <label htmlFor={"lowMemory"} className="inline-block ml-2 text-sm font-medium">Low Memory
                            Mode</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"fullPrecision"} onChange={(e) => handleFullPrecision(e.target.checked)}
                                     checked={fullPrecision}/>
                        <label htmlFor={"fullPrecision"} className="inline-block ml-2 text-sm font-medium">Full
                            Precision</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"halfModel"} onChange={(e) => handleHalfModel(e.target.checked)}
                                     checked={halfModel}/>
                        <label htmlFor={"halfModel"} className="inline-block ml-2 text-sm font-medium">Use Half
                            Model</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"cpuGeneration"} onChange={(e) => handleCpuGeneration(e.target.checked)}
                                     checked={cpuGeneration}/>
                        <label htmlFor={"cpuGeneration"} className="inline-block ml-2 text-sm font-medium">Force CPU
                            Generation</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"cpuOffloading"} onChange={(e) => handleCpuOffloading(e.target.checked)}
                                     checked={cpuOffloading}/>
                        <label htmlFor={"cpuOffloading"} className="inline-block ml-2 text-sm font-medium">Force CPU
                            Offloading</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"testMode"} onChange={(e) => handleTestMode(e.target.checked)}
                                     checked={testMode}/>
                        <label htmlFor={"testMode"} className="inline-block ml-2 text-sm font-medium">Test Mode</label>
                    </div> */}
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"categoryPopup"} onChange={(e) => handleCategoryPopup(e.target.checked)}
                                     checked={categoryPopup}/>
                        <label htmlFor={"categoryPopup"} className="inline-block ml-2 text-sm font-medium">Category
                            Popup Before Generation</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"preferOpenAIModel"} onChange={(e) => handlePreferOpenAIModel(e.target.checked)}
                                     checked={preferOpenAIModel}/>
                        <label htmlFor={"preferOpenAIModel"} className="inline-block ml-2 text-sm font-medium">Prefer OpenAI model</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"useAIHordeModels"} onChange={(e) => handleUseAIHordeModels(e.target.checked)}
                                     checked={useAIHordeModels}/>
                        <label htmlFor={"useAIHordeModels"} className="inline-block ml-2 text-sm font-medium">Use AI Horde models</label>
                    </div>
                    <div className={"flex flex-row items-center py-2"}>
                        <ToggleInput id={"useDevApi"} onChange={(e) => handleUseDevApi(e.target.checked)} checked={useDevApi} />
                        <label htmlFor={"useDevApi"}
                            className="inline-block ml-2 text-sm font-medium">Use Dev Api</label>
                    </div>
                </div>
                <hr/>
                <h2 className={"text-xl font-bold pt-10"}>Server Control Panel</h2>
                <div className="grid grid-cols-2 grid-rows-3 gap-2">
                    <div className="grid col-span-2 py-5">
                        This section is used in conjuction with the PManager app and the Promptus Preview App. The PManager app is used to start and stop the servers only once the server(s) are installed.
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">GPU Server</span>
                        <div className="flex flex-row gap-2 justify-start">
                            <button onClick={() => startPManagerServer("gpu")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("gpu")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">CPU Server</span>
                        <div className="flex flex-row gap-2">
                            <button onClick={() => startPManagerServer("cpu")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("cpu")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">Horde Server</span>
                        <div className="flex flex-row gap-2">
                            <button onClick={() => startPManagerServer("horde")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("horde")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">ComfyUI Server</span>
                        <div className="flex flex-row gap-2">
                            <button onClick={() => startPManagerServer("comfyui")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("comfyui")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">Cosy Server</span>
                        <div className="flex flex-row gap-2">
                            <button onClick={() => startPManagerServer("cosy")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("cosy")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="flex h-min flex-row justify-between items-center">
                        <span className="text-lg">CWorker Server</span>
                        <div className="flex flex-row gap-2">
                            <button onClick={() => startPManagerServer("cworker")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={StartIcon} className="w-7 h-7" />
                            </button>
                            <button onClick={() => stopPManagerServer("cworker")} className={"rounded w-10 p-2 bg-yellow text-dark-blue font-semibold shadow"}>
                                <img src={SquareStopIcon} className="w-7 h-7" />
                            </button>
                        </div>
                    </div>
                    <div className="grid col-span-2 gap-3 bg-white/40 backdrop-blur rounded-md p-3 mt-5">
                        {statusError ? (
                            <div className="text-red-600 text-center font-bold text-lg uppercase">
                            {statusErrorMessage}
                            </div>
                        ) : null}
                    </div>
                </div>
                {electronBridge.isElectron && (
                    <>
                        <hr className="mt-10"/> 
                        <h3 className={"text-lg font-bold py-5"}>Backup Data</h3>
                        <div className={"py-2 pt-0"}>
                            <label className="block mb-2 text-sm font-medium " htmlFor="saveDirectory">Your directory to save your generated images: </label>
                            <input type="text" name="saveDirectory" value={directory} onChange={(e) => setDirectory(e.target.value)}
                                className="w-full rounded-lg text-dark-blue border-0 p-2"
                                placeholder="C:\\path\to\images"/>
                            <div className="flex flex-row justify-center">
                                <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow mt-5"} onClick={saveDirectory}>Save</button>
                                {canSelectDirectory ? (
                                    <button 
                                        className={"rounded w-10 p-1 bg-yellow text-dark-blue mt-5 ms-2"} 
                                        onClick={() => ipcRenderer.send("openDirectory", directory)}
                                    >
                                        <img src={OpenFolder}/>
                                    </button>
                                ) : (
                                    <FeatureTooltip feature="directorySelection" placement="top">
                                        <button 
                                            className={"rounded w-10 p-1 bg-gray-400 text-gray-600 mt-5 ms-2 cursor-not-allowed opacity-50"} 
                                            disabled
                                        >
                                            <img src={OpenFolder} style={{opacity: 0.5}}/>
                                        </button>
                                    </FeatureTooltip>
                                )}
                            </div>

                        </div>
                    </>

                )}
                <hr className="mt-5"/>
                <h3 className={"text-lg font-bold py-8"}>Offline Server Settings
                </h3>
                {/* <div className={"py-2 pt-0"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="batchNumber">Image Batch
                        Size</label>
                    <input type="number" name="batchNumber" value={batchNumber}
                           onChange={(e) => setBatchNumber(e.target.value)}
                           className="w-full rounded-lg text-dark-blue border-0 p-2"
                           placeholder="Batch Number"/>
                </div> */}
                <div className={"py-2 pt-0"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="apiHost">GPU Server
                        Hostname</label>
                    <input type="text" name="apiLocalGPU" value={apiLocalGPU}
                           onChange={(e) => setApiLocalGPU(e.target.value)}
                           className="w-full rounded-lg rounded-b-none text-dark-blue border-0 p-2 h-11"
                           placeholder="http://localhost:[Insert local server port number]"/>
                    <div className="bg-dark-blue/40 p-5 rounded-b-lg flex flex-row justify-between">
                        <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow"}
                                onClick={() => saveApiSettings(apiLocalGPU, "GPU")}>Save GPU Server Settings
                        </button>
                        <div className={"flex flex-row items-center py-2 self-start"}>
                            <ToggleInput id={"enableGPU"} onChange={(e) => handleEnableGPU(e.target.checked)}
                                         checked={enableGPU}/>
                            <label htmlFor={"enableGPU"} className="inline-block ml-2 text-sm font-medium">Enable GPU Server</label>
                        </div>
                    </div>
                </div>
                <div className={"py-2 pt-0 mb-3"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="apiHost">CPU Server
                        Hostname</label>
                    <input type="text" name="apiLocalCPU" value={apiLocalCPU}
                           onChange={(e) => setApiLocalCPU(e.target.value)}
                           className="w-full rounded-lg rounded-b-none text-dark-blue border-0 p-2 h-11"
                           placeholder="http://localhost:[Insert local server port number]"/>
                    <div className="bg-dark-blue/40 p-5 rounded-b-lg flex flex-row justify-between">
                        <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow"}
                                onClick={() => saveApiSettings(apiLocalCPU, "CPU")}>Save CPU Server Settings
                        </button>
                        <div className={"flex flex-row items-center py-2 self-start"}>
                            <ToggleInput id={"enableCPU"} onChange={(e) => handleEnableCPU(e.target.checked)}
                                         checked={enableCPU}/>
                            <label htmlFor={"enableCPU"} className="inline-block ml-2 text-sm font-medium">Enable CPU Server</label>
                        </div>
                    </div>
                </div>
                <div className={"py-2 pt-0 mb-3"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="apiCosyHost">Cosy Server
                        Hostname</label>
                    <input type="text" name="apiLocalCosy" value={apiLocalCosy}
                           onChange={(e) => setApiLocalCosy(e.target.value)}
                           className="w-full rounded-lg rounded-b-none text-dark-blue border-0 p-2 h-11"
                           placeholder="http://localhost:[Insert local server port number]"/>
                    <div className="bg-dark-blue/40 p-5 rounded-b-lg flex flex-row justify-between">
                        <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow"}
                                onClick={() => saveApiSettings(apiLocalCosy, "Cosy")}>Save Cosy Server Settings
                        </button>
                        <div className={"flex flex-row items-center py-2 self-start"}>
                            <ToggleInput id={"enableCosy"} onChange={(e) => handleEnableCosy(e.target.checked)}
                                         checked={enableCosy}/>
                            <label htmlFor={"enableCosy"} className="inline-block ml-2 text-sm font-medium">Enable Cosy Server</label>
                        </div>
                    </div>
                </div>
                {message.type ? <div
                    className={`rounded-lg p-2 ${message.type === "error" ? 'bg-red-600' : 'bg-dark-blue/40'}`}>{message.message}</div> : null}
                {!loading ?
                    <>
                        <button className={"rounded w-1/2 mx-auto my-2 p-2 bg-dark-blue text-yellow shadow"}
                                onClick={clearApiSettings}>Reset Server Settings
                        </button>
                    </>
                    : null}

            </div>
            <Modal open={openNodeTest} onClose={() => setOpenNodeTest(false)} center>
                <h2 className="text-2xl mb-5 font-bold">Node Testing</h2>
                <div className={"py-2 pt-0 mt-3"}>
                    <input type="text" name="nodeAccountNo" value={nodeAccountNo} onChange={(e) => setNodeAccountNo(e.target.value)}
                           className="w-full rounded-lg text-dark-blue border-2 border-dark-blue p-2 h-11"
                           placeholder="Account Number" />
                    <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow mt-5"} onClick={() => saveNodeTest()}>Save Account Number</button>
                    {nodeloading ?
                        <svg aria-hidden="true" role="status" class="inline w-7 h-7 ms-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                        </svg>
                        : null}
                </div>
            </Modal>
        </div>
    );

}
